
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { StockTransferService } from './stock-transfer-service';
import { CommonResponseModel } from '@project-management-system/shared-models';

@ApiTags('stock-transfer')
@Controller('stock-transfer')
export class StockTransferController{
    constructor(private stocktransferService: StockTransferService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
        ) {}

        @Post('/createStockTransfer')
        async createStockTransfer(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.stocktransferService.createStockTransfer(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
        }
 
        @Post('/CreateNegativeStock')
        async CreateNegativeStock(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.stocktransferService.CreateNegativeStock(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
        }
        @Post('/getStockTransfers')
        async getStockTransfers(): Promise<CommonResponseModel> {
        try {
            return await this.stocktransferService.getStockTransfers();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
        }

        @Post('/getStockNegatives')
        async getStockNegatives(): Promise<CommonResponseModel> {
        try {
            return await this.stocktransferService.getStockNegatives();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
        }
        

        @Post('/receiveStock')
        async receiveStock(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.stocktransferService.receiveStock(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
        }

}

